import SubmitRfqQuote from '../../../../../../client/src/rfq/src/viewmodel/SubmitRfqQuoteViewModel';
import { DesBaseRfq } from '../utils/des-base-rfq';

export default class DesSubmitRfqQuote extends DesBaseRfq {

    constructor() {
        console.log('DesSubmitRfqQuote invoked');
        super(SubmitRfqQuote);
    }

    get collaborationspaceid() {
        return this.getAttribute('collaborationspaceid') || this.getAttribute('collaborationspace-id');
    }

    get rfqquoteid() {
        return this.getAttribute('rfqquoteid') || this.getAttribute('rfq-quote-id');
    }

    getProps() {
        return {
            collaborationspaceid: this.collaborationspaceid,
            rfqquoteid: this.rfqquoteid
        };
    }

    static get observedAttributes() {
        return [ ...DesBaseRfq.observedAttributes];
    }
}
if (!window.customElements.get('des-submit-rfq-quote')) {
    window.customElements.define('des-submit-rfq-quote', DesSubmitRfqQuote);
}
